import React, { useEffect, useContext } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useCalculateInsurance from '../../hooks/useCalculateInsurance';
import SelectedInsuranceCard from '../../components/SelectedInsuranceCard';
import InsuranceSteps from '../../components/InsuranceSteps';
import InsuranseInfo from './components/InsuranseInfo';
import BottomConfirm from './components/BottomConfirm';
import TouristData from './components/TouristData';
import BackToPreviousPage from '../../ui/BackToBtn';
import { Company, Offers, Tourist } from '../../types';
import { MainWrapper, Content, PageTitle, SelectedCard } from './index.style';
import { InsuranceContext } from '../../context/insuranceContext';

const FourthStep: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { insurance, insuranceParameters } = useContext(InsuranceContext);  
  const { getOffers, availableOffers } = useCalculateInsurance();
  const { beneficiary, details } = insurance || {};
  const { selectedTourists } = insuranceParameters || {};

  useEffect(() => {
    getOffers(insurance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details, beneficiary.length]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const companies = availableOffers?.offersResponce?.companies || [];

  const selectedCompany = companies?.filter(
    (company: Company) => company.name === insuranceParameters.selectedInsurance.name
  );

  const selectedOffer = selectedCompany[0]?.offers?.filter(
    (offer: Offers) => offer.sum === insuranceParameters.selectedInsurance.sum
  );  

  return (
    <MainWrapper>
      <Content>
        <InsuranceSteps activeStep={4} />
        <Box sx={{position: 'relative'}}>
          <BackToPreviousPage url={'/buy-insurance'}/>
          <PageTitle>{t('confirm_order')}</PageTitle>
        </Box>
        {selectedOffer && (
          <SelectedCard>
            <SelectedInsuranceCard
              parameters={insuranceParameters}
              selectedOffer={selectedOffer}
            />
            {selectedTourists.map((tourist: Tourist, index: number) => {
              return <TouristData key={`${tourist.name}${index}`} tourist={tourist} index={index} />;
            })}
          </SelectedCard>
        )}
        <InsuranseInfo />
        <BottomConfirm 
          selectedOffer={selectedOffer} 
        />
      </Content>
    </MainWrapper>
  );
};

export default FourthStep;
